import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {routing} from '../../app.routing';
import {UserOverviewProfileComponent} from '~features/user-overview-profile/user-overview-profile.component';
import {ClubListComponent} from './club-list/club-list.component';
import {ManageComponent} from './manage.component';
import {BaseUserListComponent} from './user-management/base-user-list.component';
import {ClubAssignmentComponent} from './user-management/club-assignment/club-assignment.component';
import {CreateUserComponent} from './user-management/create-user/create-user.component';
import {EditUserComponent} from './user-management/edit-user/edit-user.component';
import {UserListComponent} from './user-management/user-list/user-list.component';
import {UserManagementComponent} from './user-management/user-management.component';
import {UserOverviewBaseComponent} from './user-management/user-overview-base/user-overview-base.component';
import {UserOverviewComponent} from './user-management/user-overview-base/user-overview/user-overview.component';
import {ModalModule} from '~shared/components/elements/modal.module';
import {TablesModule} from '~shared/components/tables/tables.module';
import {TooltipModule} from '~shared/components/tooltip/tooltip.module';
import {FilterPipe} from '~shared/pipes/filter.pipe';
import {NavigationModule} from '~core/components/navigation.module';
import {FormValidationModule} from '~core/components/form-validation/form-validation.module';
import {FormFieldsModule} from '~shared/components/form-fields/form-fields.module';
import {ButtonsModule} from '~shared/components/buttons/buttons.module';

/**
 * Module for the Manage section
 */
@NgModule({
  declarations: [
    ClubListComponent,
    CreateUserComponent,
    EditUserComponent,
    UserListComponent,
    UserOverviewComponent,
    BaseUserListComponent,
    UserManagementComponent,
    ManageComponent,
    UserOverviewProfileComponent,
    UserOverviewBaseComponent,
    FilterPipe,
    ClubAssignmentComponent
  ],
  exports: [
    ClubListComponent,
    CreateUserComponent,
    EditUserComponent,
    UserListComponent,
    UserOverviewComponent,
    BaseUserListComponent,
    UserManagementComponent,
    ManageComponent,
    UserOverviewProfileComponent,
    UserOverviewBaseComponent,
  ],
  imports: [
    ReactiveFormsModule,
    routing,
    FormsModule,
    NavigationModule,
    FormValidationModule,
    CommonModule,
    ButtonsModule,
    FormFieldsModule,
    NgSelectModule,
    TooltipModule,
    TablesModule,
    ModalModule
  ]
})
export class ManageModule {
}
